import styled from 'styled-components';
import { createPortal } from 'react-dom';
import ModifyPoint from '../../../modifyLayers/points/ModifyPoints';
import Checkbox from '../../../sidebars/sidebarElements/LayerCheckbox';
import SidebarTemplate from '../../../sidebars/sidebarElements/SidebarTemplate';

import { useProject } from '@contexts/Project.context';
import Alert from '@components/alert/Alert';

const Wrapper = styled.div`
	padding: 20px 20px 200px;
`;

const SidebarRow = styled.div`
	display: grid;
	grid-template-columns: 1fr 50px;
	align-items: center;
	&:hover {
		cursor: pointer;
		color: white;
	}

	label {
		text-transform: capitalize;
	}
`;

const PopoverHolder = styled.div`
	position: relative;
`;

const DetectionsPalette = ({}) => {
	const { pickedModelClasses, colorScheme, modifyLayersSidebarRef, dispatch } = useProject();
	if (!modifyLayersSidebarRef?.current) return null;

	const handleCheck = (id, visible) => {
		const { color } = colorScheme[id];
		dispatch({
			type: 'setColorScheme',
			payload: { ...colorScheme, [id]: { visible, color } },
		});
	};

	return (
		<>
			{createPortal(
				<SidebarTemplate
					zindex="2"
					sidebarId="detectionsPalette"
					header="Modify Palette"
					closeable>
					<Wrapper>
						{pickedModelClasses?.length ? (
							pickedModelClasses?.map(({ label, id }) => (
								<div key={`class-${id}`}>
									<SidebarRow>
										<Checkbox
											defaultChecked={colorScheme[id]?.visible ?? false}
											canEdit={false}
											label={label}
											onCheck={() => handleCheck(id, true)}
											onUncheck={() => handleCheck(id, false)}
										/>
										<PopoverHolder>
											<ModifyPoint label={label} id={id} />
										</PopoverHolder>
									</SidebarRow>

									<hr className="my-3" />
								</div>
							))
						) : (
							<Alert>No detections available to modify.</Alert>
						)}
					</Wrapper>
				</SidebarTemplate>,
				modifyLayersSidebarRef.current
			)}
		</>
	);
};

export default DetectionsPalette;
